import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {isDefined} from '../../commons/commons';
import {Router} from '@angular/router';
import * as _ from 'lodash';
import {HierarchyEntity, HierarchyService} from '../hierarchy.service';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';

interface PathComponent {
    path: string;
    segment: string;
}

@Component({
    selector: 'app-entity-path',
    templateUrl: './entity-path.component.html',
    styleUrls: ['./entity-path.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityPathComponent implements OnInit {

    @Input() path: string;
    @Input() space: boolean;
    @Input() disabled: boolean;
    @Input() targetUrl: string | string[];

    selectedEntity: Observable<HierarchyEntity>;

    constructor(private readonly hierarchyService: HierarchyService,
                private readonly router: Router) {
    }

    ngOnInit() {
        this.selectedEntity = this.hierarchyService.selection;
    }

    get putSpace(): boolean {
        return isDefined(this.space) ? this.space : true;
    }

    isDisabled(path: string, selection: HierarchyEntity): boolean {
        if (this.disabled) {
            return true;
        }
        return !!selection && selection.path === path;
    }

    mkPathComponents(path: string): PathComponent[] {
        if (!path) {
            return [];
        }
        return path.split('/').reduce((segments: PathComponent[], segment: string) => [...segments, {
            path: segments.length ? `${segments[segments.length - 1].path}/${segment}` : segment,
            segment
        }], []);
    }

    onSelectEntity(path: string) {
        if (!this.disabled) {
            const targetUrl = this.targetUrl ? (_.isArray(this.targetUrl) ? this.targetUrl : [this.targetUrl]) : [];
            this.hierarchyService.findEntityByPath(path).pipe(first()).toPromise()
                .then(targetEntity => {
                    return this.router.navigate(targetUrl, {
                        queryParams: {
                            id: targetEntity?.id || undefined
                        },
                        queryParamsHandling: 'merge'
                    });
                });
        }
    }
}
